import React, { Suspense, useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import LoadingIndicator from "../../../Loaders/LoadingIndicator";

const ScalePopup = ({
  open,
  onClose,
  children,
  size = "large",
}) => {

  const prevOpenRef = useRef(false);
  const [lockedSize, setLockedSize] = useState(size);

  useEffect(() => {
    const wasOpen = prevOpenRef.current;
    if (open && !wasOpen) {
      setLockedSize(size);
    }
    prevOpenRef.current = open;
  }, [open, size]);

  const isLarge = lockedSize === "large";

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={null}
      closable={false}
      centered
      destroyOnClose
      width={isLarge ? "90vw" : 600}
      style={isLarge ? { top: 0 } : {}}
      bodyStyle={
        isLarge
          ? {
              padding: 0,
              height: "90vh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }
          : {
              padding: 0,
              height: "min(720px, 90vh)",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }
      }
    >
      <Suspense fallback={<LoadingIndicator message="Loading scale..." />}>
        {children}
      </Suspense>
    </Modal>
  );
};

export default ScalePopup;
